// Project data organized in a single, maintainable structure
export const projectsData = {
  robolink: {
    title: "RoboLink – Wireless Robot Controller",
    description: "RoboLink connects your phone to Arduino-based robots via Wi-Fi & Bluetooth — with a fully customizable controller interface. Built with Flutter, it features a drag-and-drop visual widget editor, live MJPEG camera streaming, multiple widget types (joysticks, buttons, sliders, D-pads, XY pads, gauges, triggers), layout save/load with preset templates, and automatic reconnection. Published on Google Play Store with an open-source Arduino Library on the official registry.",
    shortDescription: "Control your robot wirelessly. Flutter app with drag-and-drop UI editor, MJPEG streaming & open-source Arduino Library.",
    category: "Hardware & IoT",
    techStack: ["Flutter", "Dart", "Android SDK", "Arduino", "ESP32", "ESP8266", "Wi-Fi UDP", "Bluetooth Classic"],
    githubLink: "https://github.com/sakibahmedshanto/RoboLink",
    demoVideo: "https://play.google.com/store/apps/details?id=com.ahmedapps.robolink",
    websiteLink: "https://robolink.studio/",
    contactEmail: "sakibsanto57@gmail.com",
    projectStats: {
      platform: "Android (iOS coming soon)",
      framework: "Flutter",
      hardware: "Dozens of Arduino boards",
      transport: "Wi-Fi UDP + Bluetooth Classic"
    },
    features: [
      {
        icon: "🎨",
        title: "Drag-and-Drop Visual Widget Editor",
        details: ["Customizable analog joystick with axis inversion & dead zones", "Toggles, buttons, sliders, D-pads, XY pads, gauges, triggers", "Layout save/load with preset templates"]
      },
      {
        icon: "📹",
        title: "Live MJPEG Camera Streaming",
        details: ["Real-time camera feed from ESP32 camera", "Flip/mirror options", "Low-latency video transmission"]
      },
      {
        icon: "📡",
        title: "3 Transport Options",
        details: ["Wi-Fi UDP communication", "Bluetooth Classic support", "Automatic reconnection with device history"]
      },
      {
        icon: "🤖",
        title: "Ready-Made Presets",
        details: ["RC Car controller layout", "Robotic Arm controller layout", "Onboarding walkthrough with interactive tutorials"]
      }
    ],
    screenshotSections: [
      {
        title: "Controller Layouts",
        screenshots: [
          {
            src: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/WhatsApp%20Image%202026-02-25%20at%201.16.41%20AM-vLK5FeJowGMbctgnaThFOq3HeNXxjQ.jpeg",
            title: "RC Car Controller",
            description: "Custom RC Car control layout with joystick and buttons"
          },
          {
            src: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/WhatsApp%20Image%202026-02-25%20at%201.16.43%20AM%20%282%29-UHJB3mW1LCG7eg9SvXvcdbyyRwySKo.jpeg",
            title: "Robotic Arm Controller",
            description: "Precision robotic arm control interface"
          },
          {
            src: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/WhatsApp%20Image%202026-02-25%20at%201.16.43%20AM-x8vnQOjgOAgtEodWUIleqiLOJmo1Cw.jpeg",
            title: "Widget Editor",
            description: "Drag-and-drop visual widget editor"
          }
        ]
      },
      {
        title: "Connectivity & Presets",
        screenshots: [
          {
            src: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/WhatsApp%20Image%202026-02-25%20at%201.16.42%20AM%20%281%29-BBrTmTSgtwTtWIyVp2S8RBimO0rn6J.jpeg",
            title: "Bluetooth Connection",
            description: "Easy Bluetooth device pairing"
          },
          {
            src: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/WhatsApp%20Image%202026-02-25%20at%201.16.42%20AM-BKmVyx7mGvW8RipFSC3oijdVFCo.jpeg",
            title: "Wi-Fi Connection",
            description: "Wi-Fi UDP configuration"
          },
          {
            src: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/WhatsApp%20Image%202026-02-25%20at%201.16.43%20AM%20%281%29-wvGdY4crStg9tKkg4nbNWQ4hMyboo.jpeg",
            title: "Layout Presets",
            description: "Ready-made templates for quick start"
          }
        ]
      }
    ],
    keyHighlights: [
      "200+ downloads on Google Play Store",
      "Open-source Arduino Library on official registry",
      "3 transport options: Wi-Fi UDP + Bluetooth Classic",
      "Live MJPEG camera streaming with flip/mirror",
      "Supports dozens of Arduino boards"
    ]
  },

  "robolink-rn": {
    title: "RoboLink – React Native Robot Controller",
    description: "RoboLink is an Android app built with React Native CLI for my Mobile Application Development academic course. It turns your phone into a fully customizable robot controller — build your own control layout with joysticks, buttons, and sliders via a drag-and-drop editor, connect via Bluetooth or Wi-Fi UDP, and get started instantly with built-in Arduino code guides. Shipped live on Google Play Store (100+ downloads).",
    shortDescription: "React Native robot controller with drag-and-drop UI builder, Bluetooth & Wi-Fi UDP support. Academic project — live on Play Store.",
    category: "Hardware & IoT",
    techStack: ["React Native", "React Native CLI", "JavaScript", "Bluetooth", "Wi-Fi UDP", "Arduino", "ESP32", "Android SDK"],
    githubLink: "https://github.com/sakibahmedshanto/Robolink",
    demoVideo: "https://play.google.com/store/apps/details?id=com.robolinkiut",
    contactEmail: "sakibsanto57@gmail.com",
    projectStats: {
      platform: "Android",
      framework: "React Native CLI",
      hardware: "Arduino / ESP32 / ESP8266",
      version: "Aug 2025"
    },
    features: [
      {
        icon: "🎮",
        title: "Custom Controller Canvas",
        details: [
          "Joystick (Move) + XABY gamepad buttons on one canvas",
          "Speed slider with live value display",
          "Custom action buttons (e.g. Lights) freely placed",
          "Preset dropdown to switch between saved layouts"
        ]
      },
      {
        icon: "✏️",
        title: "Drag-and-Drop Edit Mode",
        details: [
          "Toggle Edit mode to reposition or delete any widget",
          "Add widgets: Direction, Action, Slider, or Joystick",
          "Configure label, map name, value and size per widget",
          "Save / Save As to persist multiple controller profiles"
        ]
      },
      {
        icon: "📡",
        title: "Dual Connectivity",
        details: [
          "Wi-Fi UDP — set IP, enable broadcast, configure transmission interval",
          "Bluetooth — pair devices, enable BT transmission at 100 ms interval",
          "Discrete or continuous transmission mode toggle",
          "Live connection status feedback"
        ]
      },
      {
        icon: "📖",
        title: "Built-in Help & Code Guides",
        details: [
          "Interactive guide: Custom Joystick Help",
          "Arduino UDP and ESP32 Bluetooth code templates",
          "Basic Car starter preset with step-by-step instructions",
          "Designed to get makers started with zero prior knowledge"
        ]
      }
    ],
    screenshotSections: [
      {
        title: "Controller & Customization",
        screenshots: [
          {
            src: "/robolink%20react%20native/custom_virtual_gamepad.webp",
            title: "Custom Virtual Gamepad",
            description: "Live controller with joystick, speed slider, and custom buttons ready for robot control"
          },
          {
            src: "/robolink%20react%20native/customizing_rearranging_buttons_and_joysticks.webp",
            title: "Edit & Rearrange Widgets",
            description: "Drag-and-drop mode to customize and reposition all controls before saving your layout"
          },
          {
            src: "/robolink%20react%20native/creating_custom_buttons.webp",
            title: "Create Custom Buttons",
            description: "Add new widgets: Direction, Action, Slider, or Joystick with custom labels and map names"
          }
        ]
      },
      {
        title: "Connectivity",
        screenshots: [
          {
            src: "/robolink%20react%20native/wifi_udp_transmission.webp",
            title: "Wi-Fi UDP Settings",
            description: "Configure device IP, enable UDP broadcast, set transmission mode and interval"
          },
          {
            src: "/robolink%20react%20native/bluetooth_transmission.webp",
            title: "Bluetooth Transmission",
            description: "Enable Bluetooth, configure transmission interval, view paired devices with live status"
          }
        ]
      },
      {
        title: "Help & Guides",
        screenshots: [
          {
            src: "/robolink%20react%20native/code_help.webp",
            title: "Built-in Code Guides",
            description: "Interactive tutorials for Custom Joystick, Arduino UDP, ESP32 Bluetooth, and Basic Car presets"
          }
        ]
      }
    ],
    keyHighlights: [
      "Live on Google Play Store — 100+ downloads",
      "Built with React Native CLI (academic course project)",
      "Dual connectivity: Bluetooth + Wi-Fi UDP",
      "Full drag-and-drop controller editor with save/load",
      "Built-in Arduino & ESP32 code guides for makers"
    ]
  },

  rahiee: {
    title: "Rahiee.AI – AI Attendance & HR System",
    description: "Cross-platform AI-powered attendance system (iOS + Android) with admin dashboard, real-time check-in tracking, pending-approval workflows, schedule management, and live session monitoring. Solo developer — shipped live on Apple App Store.",
    shortDescription: "AI-powered HR & attendance system live on both iOS App Store and Android",
    category: "AI & HR Tech",
    techStack: ["Flutter", "Dart", "iOS SDK", "Android SDK", "Firebase", "GetX", "REST APIs", "Xcode", "Gradle"],
    githubLink: "https://github.com/sakibahmedshanto",
    demoVideo: "https://apps.apple.com/app/rahiee-ai",
    contactEmail: "sakibsanto57@gmail.com",
    projectStats: {
      platform: "iOS + Android",
      framework: "Flutter",
      backend: "Firebase",
      role: "Sole Developer"
    },
    features: [
      { icon: "🤖", title: "AI-Powered Attendance", details: ["Real-time check-in tracking", "Pending-approval workflows"] },
      { icon: "📊", title: "Admin Dashboard", details: ["Performance analytics", "Schedule management"] },
      { icon: "🍎", title: "Live on App Store", details: ["Navigated Apple Review process", "Managed provisioning profiles"] }
    ],
    screenshotSections: [
      {
        title: "Authentication & Onboarding",
        screenshots: [
          { src: "/rahiee-screenshots/splash_screen.jpg", title: "Splash Screen", description: "App launch screen with branding" },
          { src: "/rahiee-screenshots/login_screen_with_google_auth_and_mail.jpg", title: "Login with Google & Email", description: "Seamless authentication options" },
          { src: "/rahiee-screenshots/login_with_email.jpg", title: "Email Login", description: "Email & password authentication" },
          { src: "/rahiee-screenshots/signup_screen.jpg", title: "Sign Up", description: "New user registration flow" },
        ]
      },
      {
        title: "Employee Check-In & Attendance",
        screenshots: [
          { src: "/rahiee-screenshots/employee_taking_selfie.jpg", title: "Selfie Capture", description: "Real-time biometric verification" },
          { src: "/rahiee-screenshots/employee_check_in_with_selfie.jpg", title: "Check-In with Selfie", description: "Verified check-in screen" },
          { src: "/rahiee-screenshots/employee_checkin_uniform_verification.jpg", title: "Uniform Verification", description: "AI checks employee dress code compliance" },
          { src: "/rahiee-screenshots/employee_checkin_uniform_verification_loading.jpg", title: "Verification Loading", description: "Processing uniform detection" },
          { src: "/rahiee-screenshots/employee_checkout.jpg", title: "Check-Out", description: "End-of-day checkout with timestamp" },
          { src: "/rahiee-screenshots/employee_checkout_no_uniform_detected.jpg", title: "No Uniform Alert", description: "Alert when dress code not met" },
          { src: "/rahiee-screenshots/employee_checkout_verification.jpg", title: "Checkout Verification", description: "Verify checkout identity" },
          { src: "/rahiee-screenshots/employee_attendance_history.jpg", title: "Attendance History", description: "View past attendance records" },
        ]
      },
      {
        title: "Employee Dashboard & Schedule",
        screenshots: [
          { src: "/rahiee-screenshots/employee_todays_schedule.jpg", title: "Today's Schedule", description: "Shift timing and tasks for today" },
          { src: "/rahiee-screenshots/employee_shedule_exchange.jpg", title: "Schedule Exchange Request", description: "Swap shifts with colleagues" },
          { src: "/rahiee-screenshots/employee_shedule_status.jpg", title: "Schedule Status", description: "View approved/pending schedule changes" },
          { src: "/rahiee-screenshots/employee_profile.jpg", title: "Employee Profile", description: "Personal details and contact info" },
          { src: "/rahiee-screenshots/employee_notification.jpg", title: "Notifications", description: "Real-time alerts and updates" },
        ]
      },
      {
        title: "Admin Dashboard & Management",
        screenshots: [
          { src: "/rahiee-screenshots/admin_dashboard.jpg", title: "Admin Dashboard", description: "Overview of all HR metrics" },
          { src: "/rahiee-screenshots/admin_dasboard_scrolled_down_view.jpg", title: "Dashboard Details", description: "Extended dashboard analytics view" },
          { src: "/rahiee-screenshots/admin_employee_management.jpg", title: "Employee Management", description: "List and manage all employees" },
          { src: "/rahiee-screenshots/admin_attendance_summary.jpg", title: "Attendance Summary", description: "Team-wide attendance overview" },
          { src: "/rahiee-screenshots/admin_attendance_table.jpg", title: "Attendance Table", description: "Detailed attendance records" },
          { src: "/rahiee-screenshots/admin_summart_reports.jpg", title: "Summary Reports", description: "Generate compliance & attendance reports" },
        ]
      },
      {
        title: "Admin Schedule & Notifications",
        screenshots: [
          { src: "/rahiee-screenshots/admin_shedule_management_table.jpg", title: "Schedule Management", description: "Create and manage employee shifts" },
          { src: "/rahiee-screenshots/admin_shedule_exchange_requests.jpg", title: "Exchange Requests", description: "Approve or deny schedule swap requests" },
          { src: "/rahiee-screenshots/admin_create_new_shedule.jpg", title: "Create New Schedule", description: "Build new shift schedules" },
          { src: "/rahiee-screenshots/admin_notification.jpg", title: "Admin Notifications", description: "System alerts and pending approvals" },
        ]
      }
    ],
    keyHighlights: [
      "Live on Apple App Store",
      "Sole mobile developer",
      "End-to-end App Store Connect pipeline",
      "Firebase real-time backend"
    ]
  },

  furnihub: {
    title: "Furnihub – Augmented Reality Furniture App",
    description: "Furnihub is an innovative e-commerce Android application developed using Flutter, allowing users to explore and purchase furniture. The app features augmented reality (AR), enabling users to visualize furniture in their living space before making a purchase. With a clean and intuitive interface, users can authenticate through Google or email, receive push notifications, and enjoy seamless interaction with Firebase backend services.",
    shortDescription: "AR-powered furniture e-commerce app with immersive shopping experience",
    category: "E-commerce & AR",
    techStack: ["Flutter", "Dart", "Firebase", "ARCore", "Google Authentication", "Firebase Cloud Messaging", "Firestore", "OAuth", "Cross-platform Development"],
    githubLink: "https://github.com/sakibahmedshanto/Furnihub_Augmented_Reality_App",
    demoVideo: "https://github.com/sakibahmedshanto/Furnihub_Augmented_Reality_App/raw/main/ScreenShots/ar_video.mp4",
    projectReport: "https://github.com/sakibahmedshanto/Furnihub_Augmented_Reality_App/raw/main/FurniHub_Final_Project_Report_210041209_210041232_210041262.pdf",
    contactEmail: "sakibsanto57@gmail.com",
    apkDownload: "https://github.com/sakibahmedshanto/Furnihub_Augmented_Reality_App/raw/main/Furnihub.apk",
    projectStats: {
      platform: "Android/iOS",
      framework: "Flutter",
      backend: "Firebase",
      arTechnology: "ARCore",
      authMethod: "Google OAuth",
      database: "Firestore"
    },
    features: [
      {
        icon: "🚀",
        title: "Immersive Augmented Reality (AR) Experience",
        details: [
          "Visualize Before You Buy: Using cutting-edge AR technology, Furnihub lets you see how furniture pieces fit and look in your actual living space, ensuring confident purchasing decisions.",
          "Enhanced Realism: The AR view provides a realistic and interactive way to place, rotate, and adjust furniture to match your room's setup."
        ]
      },
      {
        icon: "🔐",
        title: "Seamless User Authentication",
        details: [
          "Effortless Sign-In: Secure and straightforward authentication via Google or Email, ensuring a smooth and secure user experience.",
          "OAuth Standards: Implemented robust authentication protocols that adhere to industry security standards for safe user data management."
        ]
      },
      {
        icon: "🔔",
        title: "Real-Time Notifications",
        details: [
          "Stay Updated: Receive instant push notifications about order updates, exclusive promotions, and new arrivals.",
          "Powered by Firebase Cloud Messaging: Ensures reliable and fast communication to keep users informed and engaged."
        ]
      },
      {
        icon: "📊",
        title: "Robust Backend Services",
        details: [
          "Scalable and Reliable: Backed by Firebase Firestore, providing scalable and secure cloud storage for all user data, ensuring smooth and uninterrupted service.",
          "Real-Time Synchronization: Data syncs seamlessly across devices, enabling users to switch between platforms without losing their shopping progress."
        ]
      },
      {
        icon: "🌐",
        title: "Smooth Cross-Platform Compatibility",
        details: [
          "Built with Flutter: Ensures a consistent and responsive experience on both Android and iOS devices.",
          "Maintained Standards: Designed and developed by adhering to the best practices in mobile app development, guaranteeing stability, performance, and user satisfaction."
        ]
      }
    ],
    screenshotSections: [
      {
        title: "Onboarding and Authentication Screens",
        screenshots: [
          {
            src: "https://github.com/sakibahmedshanto/Furnihub_Augmented_Reality_App/raw/main/ScreenShots/splash_screen.jpg",
            title: "Splash Screen",
            description: "Welcome screen with app branding and smooth loading experience"
          },
          {
            src: "https://github.com/sakibahmedshanto/Furnihub_Augmented_Reality_App/raw/main/ScreenShots/welcome.gif",
            title: "Login With Google",
            description: "Seamless Google authentication integration"
          }
        ]
      },
      {
        title: "Main Features",
        screenshots: [
          {
            src: "https://github.com/sakibahmedshanto/Furnihub_Augmented_Reality_App/raw/main/ScreenShots/home.jpg",
            title: "Home Screen",
            description: "Browse furniture categories and featured items with clean, intuitive design"
          },
          {
            src: "https://github.com/sakibahmedshanto/Furnihub_Augmented_Reality_App/raw/main/ScreenShots/product.jpg",
            title: "Product Details Screen",
            description: "Comprehensive product information with specifications and pricing"
          },
          {
            src: "https://github.com/sakibahmedshanto/Furnihub_Augmented_Reality_App/raw/main/ScreenShots/ar_img.jpg",
            title: "AR Furniture View Screen",
            description: "Immersive AR experience for furniture visualization in real space"
          }
        ]
      },
      {
        title: "Navigation and Contact",
        screenshots: [
          {
            src: "https://github.com/sakibahmedshanto/Furnihub_Augmented_Reality_App/raw/main/ScreenShots/Drawer.jpg",
            title: "Navigation Drawer",
            description: "Easy access to all app features and sections"
          },
          {
            src: "https://github.com/sakibahmedshanto/Furnihub_Augmented_Reality_App/raw/main/ScreenShots/contact.jpg",
            title: "Contact Screen",
            description: "Customer support and communication options"
          }
        ]
      }
    ],
    keyHighlights: [
      "Innovative AR technology for real-world furniture visualization",
      "Cross-platform Flutter development for Android and iOS",
      "Firebase backend with real-time data synchronization",
      "Google OAuth authentication implementation",
      "Push notifications with Firebase Cloud Messaging",
      "Clean and intuitive user interface design",
      "Scalable cloud architecture with Firestore",
      "Industry-standard security protocols"
    ]
  },

  pastryparadise: {
    title: "E-commerce App for Pastry Paradise Bakery",
    description: "Developed a full-stack e-commerce solution for Pastry Paradise, a local bakery specializing in custom cakes and pastries. Built cross-platform mobile and web applications with intuitive UI for browsing, ordering, and real-time order tracking.",
    shortDescription: "Full-stack e-commerce solution for custom cake and pastry ordering",
    category: "E-commerce",
    techStack: ["Flutter", "Dart", "Firebase", "Payment Integration", "Real-time Tracking", "Cross-platform"],
    githubLink: "https://github.com/sakibahmedshanto/pastryparadise",
    demoVideo: "https://play.google.com/store/apps/details?id=com.sakibahmedshanto.pastryparadise&pcampaignid=web_share",
    contactEmail: "sakibsanto57@gmail.com",
    projectStats: {
      platform: "Android/iOS",
      framework: "Flutter",
      backend: "Firebase",
      paymentMethod: "Integrated",
      orderTracking: "Real-time"
    },
    features: [
      {
        icon: "🧁",
        title: "Custom Cake Ordering",
        details: ["Browse specialty cakes and pastries", "Custom order placement with specifications"]
      },
      {
        icon: "📱",
        title: "Cross-Platform Experience",
        details: ["Native mobile apps for Android and iOS", "Responsive web application"]
      },      {
        icon: "🔔",
        title: "Real-Time Order Tracking",
        details: ["Live order status updates", "Push notifications for order progress"]
      }
    ],
    screenshotSections: [
      {
        title: "Onboarding and Authentication",
        screenshots: [
          {
            src: "https://github.com/sakibahmedshanto/pastryparadise/raw/main/screenshots/1.jpg",
            title: "Splash Screen",
            description: "Welcome screen with bakery branding and smooth loading experience"
          },
          {
            src: "https://github.com/sakibahmedshanto/pastryparadise/raw/main/screenshots/2.jpg",
            title: "Welcome Screen",
            description: "Introduction to Pastry Paradise app features"
          },
          {
            src: "https://github.com/sakibahmedshanto/pastryparadise/raw/main/screenshots/3.jpg",
            title: "Login with Google",
            description: "Seamless Google authentication integration"
          }
        ]
      },
      {
        title: "Main Features",
        screenshots: [
          {
            src: "https://github.com/sakibahmedshanto/pastryparadise/raw/main/screenshots/4.jpg",
            title: "Home Screen",
            description: "Browse bakery items and featured products with elegant design"
          },
          {
            src: "https://github.com/sakibahmedshanto/pastryparadise/raw/main/screenshots/5.jpg",
            title: "Navigation Drawer",
            description: "Easy access to all app features and sections"
          },
          {
            src: "https://github.com/sakibahmedshanto/pastryparadise/raw/main/screenshots/6.jpg",
            title: "Product Details Screen",
            description: "Comprehensive product information with custom ordering options"
          }
        ]
      },
      {
        title: "Cart and Orders",
        screenshots: [
          {
            src: "https://github.com/sakibahmedshanto/pastryparadise/raw/main/screenshots/7.jpg",
            title: "Cart Screen",
            description: "Review selected items before checkout"
          },
          {
            src: "https://github.com/sakibahmedshanto/pastryparadise/raw/main/screenshots/8.jpg",
            title: "Order Screen",
            description: "Order management and tracking interface"
          },
          {
            src: "https://github.com/sakibahmedshanto/pastryparadise/raw/main/screenshots/9.jpg",
            title: "Contact Screen",
            description: "Customer support and bakery contact information"
          }
        ]
      }
    ],
    keyHighlights: [
      "Full-stack e-commerce solution",
      "Custom cake ordering system",
      "Real-time order tracking",
      "Cross-platform compatibility"
    ]
  },

  catering: {
    title: "Catering Management System – Sat Sotero",
    description: "Developed a comprehensive catering management system for Sat Sotero Catering Service, serving Daffodil International University's dormitory. Created mobile and web applications for meal pre-ordering with advanced scheduling capabilities.",
    shortDescription: "Comprehensive catering management system for university dormitory",
    category: "Management System",
    techStack: ["Flutter", "Firebase", "Scheduling System", "University Integration", "Meal Management"],
    githubLink: "https://github.com/sakibahmedshanto/Daffodil_Catering_Service",
    demoVideo: "https://play.google.com/store/apps/details?id=com.sakibahmedshanto.daffodilcatering&pcampaignid=web_share",
    contactEmail: "sakibsanto57@gmail.com",
    projectStats: {
      platform: "Android/iOS/Web",
      framework: "Flutter",
      backend: "Firebase",
      target: "University Dormitory",
      scheduling: "Advanced"
    },
    features: [
      {
        icon: "🍽️",
        title: "Meal Pre-ordering System",
        details: ["Schedule meals in advance", "Menu browsing and selection"]
      },
      {
        icon: "📅",
        title: "Advanced Scheduling",
        details: ["Weekly meal planning", "Automated schedule management"]
      },      {
        icon: "🏫",
        title: "University Integration",
        details: ["Dormitory-specific features", "Student ID integration"]
      }
    ],    screenshotSections: [
      {
        title: "Authentication and Setup",
        screenshots: [
          {
            src: "https://github.com/sakibahmedshanto/Daffodil_Catering_Service/raw/main/screenshots/splashscreen.jpg",
            title: "Splash Screen",
            description: "University catering service branding and welcome screen"
          },
          {
            src: "https://github.com/sakibahmedshanto/Daffodil_Catering_Service/raw/main/screenshots/siginWithGoogle.jpg",
            title: "Sign in with Google",
            description: "Google authentication for quick access"
          },
          {
            src: "https://github.com/sakibahmedshanto/Daffodil_Catering_Service/raw/main/screenshots/signinWithMail.jpg",
            title: "Sign in with Email",
            description: "Email authentication for university students"
          }
        ]
      },
      {
        title: "Main Features",
        screenshots: [
          {
            src: "https://github.com/sakibahmedshanto/Daffodil_Catering_Service/raw/main/screenshots/homescreen.jpg",
            title: "Home Screen",
            description: "Daily meal options and scheduling interface"
          },
          {
            src: "https://github.com/sakibahmedshanto/Daffodil_Catering_Service/raw/main/screenshots/meals.jpg",
            title: "Meals Screen",
            description: "Browse available meals and menu options"
          },
          {
            src: "https://github.com/sakibahmedshanto/Daffodil_Catering_Service/raw/main/screenshots/drawer.jpg",
            title: "Navigation Drawer",
            description: "Easy access to all catering service features"
          }
        ]
      },
      {
        title: "Order Management",
        screenshots: [
          {
            src: "https://github.com/sakibahmedshanto/Daffodil_Catering_Service/raw/main/screenshots/cart.jpg",
            title: "Cart Screen",
            description: "Review selected meals before confirmation"
          },
          {
            src: "https://github.com/sakibahmedshanto/Daffodil_Catering_Service/raw/main/screenshots/orderDetails.jpg",
            title: "Order Details",
            description: "Comprehensive meal ordering and scheduling system"
          },
          {
            src: "https://github.com/sakibahmedshanto/Daffodil_Catering_Service/raw/main/screenshots/confirmOrder.jpg",
            title: "Order Confirmation",
            description: "Meal order confirmation and schedule details"
          },
          {
            src: "https://github.com/sakibahmedshanto/Daffodil_Catering_Service/raw/main/screenshots/orderHistory.jpg",
            title: "Order History",
            description: "Track previous orders and meal history"
          }
        ]
      }
    ],
    keyHighlights: [
      "Comprehensive catering management",
      "Advanced scheduling system",
      "University dormitory integration",
      "Mobile and web applications"
    ]
  },

  "dhaka-navigator": {
    title: "Dhaka City Navigator – Offline Bus Route App",
    description: "Developed an offline-first mobile application to help users navigate Dhaka city using local bus transportation. Implemented comprehensive database of bus routes, stops, and transfer points for efficient trip planning. Achieved 800+ downloads with 28 regular active users.",
    shortDescription: "Offline-first navigation app for Dhaka city bus routes",
    category: "Navigation & Transport",
    techStack: ["Flutter", "Offline Database", "Route Planning", "Local Transportation", "SQLite"],
    githubLink: "https://github.com/sakibahmedshanto/DhakaLocalBus",
    demoVideo: "https://play.google.com/store/apps/details?id=com.ahmedapps.dhakalocalbus",
    contactEmail: "sakibsanto57@gmail.com",
    projectStats: {
      platform: "Android",
      framework: "Flutter",
      database: "SQLite",
      users: "1500+ Downloads",
      activeUsers: "28 Regular"
    },
    features: [
      {
        icon: "🚌",
        title: "Comprehensive Bus Route Database",
        details: ["Complete Dhaka bus routes", "Bus stops and transfer points"]
      },
      {
        icon: "📱",
        title: "Offline-First Design",
        details: ["Works without internet", "Local database storage"]
      },      {
        icon: "🗺️",
        title: "Trip Planning",
        details: ["Efficient route suggestions", "Transfer point optimization"]
      }
    ],
    screenshotSections: [
      {
        title: "App Interface & Features",
        screenshots: [
          {
            src: "https://play-lh.googleusercontent.com/nn_2t95N7callB7BORMvsd-1sPzsEDu6ISYPmW3ESJZ7b8f5VolVFy9Oc0WMlC7S9tI=w5120-h2880-rw",
            title: "Main Interface",
            description: "Primary app interface for Dhaka bus route navigation"
          },
          {
            src: "https://play-lh.googleusercontent.com/9Fnn4VTXlHf9QV8rw9CmLPffJRiwfkPFLNjMIes1gE42rwoB4C3FhiZ7gw2rCDF3BHI=w5120-h2880-rw",
            title: "Route Search",
            description: "Search and discover bus routes across Dhaka city"
          },
          {
            src: "https://play-lh.googleusercontent.com/Je2JtTLV-TV0biHUgZC_2MJjfbdyy8knCA4w_jkQTsjmQWpzCmGyRLbTNQHuNwBp-oCc=w5120-h2880-rw",
            title: "Route Details",
            description: "Detailed bus route information and stops"
          },
          {
            src: "https://play-lh.googleusercontent.com/lhUp81HOoecA1mBD6AGbOiyZZJ27MyDur0N_imjbZQpg0f1MD9-CFpsTkj-EkuNw2A=w5120-h2880-rw",
            title: "Navigation Features",
            description: "Offline navigation and trip planning features"
          }
        ]
      }
    ],
    keyHighlights: [
      "1500+ downloads achieved",
      "28 regular active users",
      "Offline-first architecture",
      "Comprehensive route database"
    ]
  },

  shondhan: {
    title: "Shondhan – AR-Enhanced Property Discovery Platform",
    description: "Led Team Hexagon in developing an innovative AI and AR-powered real estate application. Implemented real-time Augmented Reality property visualization using ARCore for immersive property exploration with natural language processing for intelligent property search.",
    shortDescription: "AI and AR-powered real estate platform with immersive property visualization",
    category: "Real Estate & AR",
    techStack: ["Flutter", "ARCore", "AI/ML", "Natural Language Processing", "Real Estate API", "Team Leadership"],
    githubLink: "https://github.com/sakibahmedshanto/shondhan",
    demoVideo: "https://www.figma.com/proto/BLZjYCeh54Kxi9KmLeWMKl/Project-Prototype",
    contactEmail: "sakibsanto57@gmail.com",
    projectStats: {
      platform: "Android/iOS",
      framework: "Flutter",
      arTechnology: "ARCore",
      aiFeatures: "NLP",
      teamRole: "Leader"
    },
    features: [
      {
        icon: "🏠",
        title: "AR Property Visualization",
        details: ["Real-time AR property viewing", "Immersive property exploration"]
      },
      {
        icon: "🤖",
        title: "AI-Powered Search",
        details: ["Natural language processing", "Intelligent property matching"]
      },      {
        icon: "👥",
        title: "Team Leadership",
        details: ["Led Team Hexagon", "Coordinated development efforts"]
      }
    ],    screenshotSections: [
      {
        title: "App Interface Showcase",
        screenshots: [
          {
            src: "https://github.com/sakibahmedshanto/shondhan/raw/main/screenshots/1.jpg",
            title: "Main Interface",
            description: "Primary app interface and navigation"
          },
          {
            src: "https://github.com/sakibahmedshanto/shondhan/raw/main/screenshots/3.jpg",
            title: "Property Search",
            description: "AI-powered property search interface"
          },
          {
            src: "https://github.com/sakibahmedshanto/shondhan/raw/main/screenshots/4.jpg",
            title: "Map Integration",
            description: "Integrated map view for property locations"
          },
          {
            src: "https://github.com/sakibahmedshanto/shondhan/raw/main/screenshots/5.jpg",
            title: "Property Details",
            description: "Comprehensive property information display"
          },
          {
            src: "https://github.com/sakibahmedshanto/shondhan/raw/main/screenshots/6.jpg",
            title: "Dashboard View",
            description: "User dashboard with property management"
          },
          {
            src: "https://github.com/sakibahmedshanto/shondhan/raw/main/screenshots/7.jpg",
            title: "Search Results",
            description: "AI-enhanced search results with matching"
          }
        ]
      },
      {
        title: "Advanced Features",
        screenshots: [
          {
            src: "https://github.com/sakibahmedshanto/shondhan/raw/main/screenshots/8.jpg",
            title: "Analytics Dashboard",
            description: "Data-driven insights and property analytics"
          },
          {
            src: "https://github.com/sakibahmedshanto/shondhan/raw/main/screenshots/9.jpg",
            title: "Property Visualization",
            description: "Advanced property visualization features"
          },
          {
            src: "https://github.com/sakibahmedshanto/shondhan/raw/main/screenshots/10.jpg",
            title: "Additional Features",
            description: "Extended functionality and user tools"
          },
          {
            src: "https://github.com/sakibahmedshanto/shondhan/raw/main/screenshots/11.jpg",
            title: "User Interface",
            description: "Clean and intuitive user interface design"
          },
          {
            src: "https://github.com/sakibahmedshanto/shondhan/raw/main/screenshots/12.jpg",
            title: "Property Management",
            description: "Property management and organization tools"
          },
          {
            src: "https://github.com/sakibahmedshanto/shondhan/raw/main/screenshots/13.jpg",
            title: "Search Functionality",
            description: "Advanced search and filtering options"
          }
        ]
      },
      {
        title: "Extended Interface Views",
        screenshots: [
          {
            src: "https://github.com/sakibahmedshanto/shondhan/raw/main/screenshots/14.jpg",
            title: "Detail Views",
            description: "Detailed property information screens"
          },
          {
            src: "https://github.com/sakibahmedshanto/shondhan/raw/main/screenshots/15.jpg",
            title: "User Experience",
            description: "Optimized user experience design"
          },
          {
            src: "https://github.com/sakibahmedshanto/shondhan/raw/main/screenshots/16.jpg",
            title: "Platform Features",
            description: "Platform-specific features and tools"
          },
          {
            src: "https://github.com/sakibahmedshanto/shondhan/raw/main/screenshots/17.jpg",
            title: "Final Interface",
            description: "Complete interface showcase"
          }
        ]
      }
    ],
    keyHighlights: [
      "AR-enhanced property discovery",
      "AI-powered search capabilities",      "Team leadership experience",
      "ARCore implementation"
    ]
  }
};

// Helper function to get project by ID
export const getProjectById = (projectId) => {
  return projectsData[projectId] || null;
};

// Helper function to get all project IDs
export const getAllProjectIds = () => {
  return Object.keys(projectsData);
};

// Helper function to get projects by category
export const getProjectsByCategory = (category) => {
  return Object.entries(projectsData)
    .filter(([_, project]) => project.category === category)
    .reduce((acc, [key, project]) => {
      acc[key] = project;
      return acc;
    }, {});
};

// Helper function to get featured projects (you can customize this logic)
export const getFeaturedProjects = () => {
  const featuredIds = ['robolink', 'robolink-rn', 'rahiee', 'furnihub', 'shondhan', 'dhaka-navigator', 'catering'];
  return featuredIds.reduce((acc, id) => {
    if (projectsData[id]) {
      acc[id] = projectsData[id];
    }
    return acc;
  }, {});
};

// Helper function to search projects by tech stack
export const searchProjectsByTech = (techName) => {
  return Object.entries(projectsData)
    .filter(([_, project]) => 
      project.techStack.some(tech => 
        tech.toLowerCase().includes(techName.toLowerCase())
      )
    )
    .reduce((acc, [key, project]) => {
      acc[key] = project;
      return acc;
    }, {});
};

export default projectsData;
